import Avatar from "@mui/material/Avatar";
import { Box, Typography, useTheme } from "@mui/material";
import { usePrivateLabel } from "context/PrivateLabelContext/UsePrivateLabelContextProvider";

interface Prop {
  nmls: number;
  company?: string;
  lastName: string;
  firstName: string;
  companyNMLS?: string;
  profilePicture?: string;
  avatar?: string;
  brokerId?: string;
}

export default function LoanOfficerInformation({
  nmls,
  company,
  lastName,
  firstName,
  profilePicture,
  companyNMLS,
  avatar,
  brokerId,
}: Prop) {
  const theme = useTheme();
  const { privateLabel } = usePrivateLabel();
  const organizationName = privateLabel
    ? privateLabel.lenderName
    : `NFTYDoor's`;

  return (
    <Box
      display={"flex"}
      borderRadius={10}
      bgcolor={theme.palette.background.paper}
      mb={3}
      py={5}
      px={7}
      position="relative"
      justifyContent={"space-between"}
      alignItems={{ xs: "center", sm: "flex-start" }}
      flexDirection={{ xs: "column", sm: "row" }}
    >
      <Box
        width={{ sm: "30%", xs: undefined }}
        mr={2}
        position="relative"
        flexDirection={"column"}
        display={"flex"}
      >
        <Box
          width={105}
          height={105}
          display={"flex"}
          borderRadius={90}
          alignSelf={"center"}
          bgcolor={theme.palette.primary.main}
          justifyContent={"center"}
        >
          <Avatar
            src={avatar ?? profilePicture}
            alt="Img avatar"
            sx={{
              padding: 0,
              width: 100,
              height: 100,
              alignSelf: "center !important",
            }}
          />
        </Box>
        <Typography
          mt={1}
          variant="h6"
          color={theme.palette.primary.main}
          alignSelf={"center"}
          textAlign="center"
          fontFamily={"Pro Display Semibold"}
        >
          {firstName} {lastName}
        </Typography>
        <Typography
          lineHeight={1}
          variant="subtitle1"
          color={theme.palette.text.primary}
          alignSelf={"center"}
          textAlign="center"
          fontFamily={"Pro Display Semibold"}
        >
          NMLS ID# {nmls}
        </Typography>
      </Box>
      <Box py={{ xs: 0, sm: 2 }} mt={{ xs: 3, sm: 0 }} flex={1}>
        <Typography
          variant="h6"
          color={theme.palette.text.primary}
          textAlign={"left"}
        >
          <span style={{ fontFamily: "Pro Display Semibold" }}>
            WELCOME! I'm glad you're here!{" "}
          </span>
          Interested in accessing your home equity? We now offer Home Equity
          Loans through {organizationName} digital lending platform. Simply fill
          out the items below and see your offer instantly!
          <br />
          {brokerId === "c9faa05f-6f32-47fb-9e89-94f97dbbb926"
            ? ""
            : "There is no obligation or credit check."}
        </Typography>
        <Typography
          variant="subtitle1"
          color={theme.palette.primary.main}
          alignSelf={"center"}
          textAlign="left"
          fontFamily={"Pro Display Semibold"}
        >
          {company}
          <br />
          NMLS ID # {companyNMLS}
        </Typography>
      </Box>
    </Box>
  );
}
